import React, { JSX } from 'react';
import {
  getBezierPath,
  Position,
  ConnectionLineComponentProps,
} from '@xyflow/react';

import { getEdgeParams } from '../utils/initialElements';
import type { ExtendedNode } from './types';

type FloatingConnectionLineProps = ConnectionLineComponentProps & {
  fromNode: any;
};

export const FloatingConnectionLine: React.FC<FloatingConnectionLineProps> = ({
  toX,
  toY,
  fromPosition,
  toPosition,
  fromNode,
}): JSX.Element | null => {
  if (!fromNode) {
    return null;
  }

  const targetNode: ExtendedNode = {
    id: 'connection-target',
    data: { label: '', expanded: false },
    position: { x: toX, y: toY },
    measured: { width: 1, height: 1 },
    internals: { positionAbsolute: { x: toX, y: toY } },
    type: 'custom',
  };

  const { sx, sy } = getEdgeParams(fromNode, targetNode);
  const [edgePath] = getBezierPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: fromPosition as Position,
    targetPosition: toPosition as Position,
    targetX: toX,
    targetY: toY,
  });

  return (
    <g>
      <path
        fill="none"
        stroke="#222"
        strokeWidth={1.5}
        className="animated"
        d={edgePath}
      />
      <circle
        cx={toX}
        cy={toY}
        fill="#fff"
        r={3}
        stroke="#222"
        strokeWidth={1.5}
      />
    </g>
  );
};
